export const SESSION_KEYS = {
  isInternal: 'jobportalIsInternal',
  internalToken: 'internalToken',
  referrer: 'jobportalReferrer',
  trackingSessionToken: 'jobportalTrackingSessionToken'
};
